<script lang="ts">
  import type { JobFilters } from '$lib/careers/types';
  import { TwistBox, TwistStack, TwistDivider } from '@twist/core';
  import FilterGroup from './FilterGroup.svelte';
  import JobCount from './JobCount.svelte';
  import BusinessUnits from './BusinessUnits.svelte';
  import ResetFiltersButton from './ResetFiltersButton.svelte';

  export let values: JobFilters;
</script>

<div data-testid="desktop-filters">
  <TwistBox display={{ min: 'none', lg: 'block' }}>
    <TwistStack align="center" justify="space-between">
      <FilterGroup filterValues={values} on:filters-change />
      <JobCount />
    </TwistStack>

    <span class="divider">
      <TwistDivider color="gray-100" thickness="1px" margin={3} />
    </span>

    <TwistStack justify="space-between" align="center" spacing={1}>
      <BusinessUnits filterValues={values.businessUnits} on:filters-change />
      <ResetFiltersButton on:filters-change />
    </TwistStack>
  </TwistBox>
</div>

<style>
  .divider {
    opacity: 30%;
  }
</style>
